import { Skeleton } from '@radix-ui/themes'

const DashboardRolloutSkelton = () => {
  return (
    <div className="w-full flex flex-col h-screen">
      <div className="grid grid-cols-4 gap-4 mb-4">
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
        <Skeleton className="h-40" />
      </div>
      <div className="flex w-full space-x-4 h-[50%] mb-4 justify-between">
        <Skeleton className="h-full w-1/2 flex-grow" />
        <Skeleton className="h-full w-1/2 flex-grow" />
      </div>
      <div className="flex w-full space-x-4 h-[50%] mb-4 justify-between">
        <div className="w-1/2 flex flex-col gap-4">
          <Skeleton className="h-40" />
          <Skeleton className="h-40 flex-grow" />
        </div>
        <Skeleton className="h-full w-1/2" />
      </div>
    </div>
  )
}

export default DashboardRolloutSkelton
